import request from '@/utils/request'

let MsgApi = {

  /*消息列表*/
  list(data) {
    return request._post('/shop/plus.msg.Index/index', data);
},
/*添加消息*/
add(data) {
    return request._post('/shop/plus.msg.Index/add', data);
},
/*修改消息*/
edit(data) {
    return request._post('/shop/plus.msg.Index/edit', data);
}, 
/*删除消息*/
del(data) {
    return request._post('/shop/plus.msg.Index/del', data);
},
/*消息详情*/
detail(data) {
  return request._post('/shop/plus.msg.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.msg.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.msg.Setting/getSetting', data, errorback);
    },
}
export default MsgApi;



// WEBPACK FOOTER //
// ./src/api/msg.js